import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface BlocksCollapsedState {
  collapsedBlocks: Record<string, boolean>;
}

export const useBlocksCollapsedStore = create<BlocksCollapsedState>()(
  persist(
    () => ({
      collapsedBlocks: {},
    }),
    {
      name: 'lbi-collapsed-blocks-storage',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const toggleBlockCollapsed = (blockId: string) => {
  useBlocksCollapsedStore.setState((state) => ({
    collapsedBlocks: {
      ...state.collapsedBlocks,
      [blockId]: !state.collapsedBlocks[blockId],
    },
  }));
};

export const setBlockCollapsed = (blockId: string, isCollapsed: boolean) => {
  useBlocksCollapsedStore.setState((state) => ({
    collapsedBlocks: {
      ...state.collapsedBlocks,
      [blockId]: isCollapsed,
    },
  }));
};

export const resetBlocksCollapsed = () => {
  useBlocksCollapsedStore.setState({ collapsedBlocks: {} });
};

export const useIsBlockCollapsed = (blockId: string) =>
  useBlocksCollapsedStore((state) => !!state.collapsedBlocks[blockId]);
